export default (function () {
  function sortTopics() {
    var review_id = $('#review_id').val();
    var form_data = new FormData();
    form_data.append('action', 'sort_topics');
    form_data.append('id', review_id);
    $(".roadmap-items .tab-wrapper__item").each(function (i) {
      var title = $(this).find(".topic_title").val();
      var badge = $(this).find(".topic_badge:checked").val();
      form_data.append('topic_title' + (i + 1), title);
      form_data.append('topic_badge' + (i + 1), badge);
    });
    $(".roadmap-items .tab-wrapper__item.show").each(function (i) {
      $(this).find(".tab-wrapper__item-number").text(i + 1);
    });
    $.ajax({
      url: settings.ajaxurl,
      type: "POST",
      contentType: false,
      processData: false,
      data: form_data,
      beforeSend: function beforeSend() {
        $(".roadmap-items").css('pointer-events', 'none');
      },
      success: function success(response) {
        $(".roadmap-items").css('pointer-events', 'initial'); // $(".response").text(response);
      }
    });
  }

  function removeTopic() {
    $(document).on('click', '.remove-topic', function (e) {
      var review_id = $('#review_id').val();
      $(this).parents(".tab-wrapper__item").addClass("hide").removeClass("show");
      $(this).parents(".tab-wrapper__item").appendTo($('.roadmap-items'));
      $(this).parents(".tab-wrapper__item").find(".topic_title").val('');
      $(this).parents(".tab-wrapper__item").find(".topic_badge[value=no]").prop('checked', true);
      var numberTopics = $(".roadmap-items .tab-wrapper__item.show").length;
      var form_data = new FormData();
      form_data.append('action', 'remove_topic');
      form_data.append('id', review_id);
      form_data.append('numberTopics', numberTopics);
      $(".roadmap-items .tab-wrapper__item").each(function (i) {
        var title = $(this).find(".topic_title").val();
        var badge = $(this).find(".topic_badge:checked").val();
        form_data.append('topic_title' + (i + 1), title);
        form_data.append('topic_badge' + (i + 1), badge);
      });
      $(".roadmap-items .tab-wrapper__item.show").each(function (i) {
        $(this).find(".tab-wrapper__item-number").text(i + 1);
      });
      $.ajax({
        url: settings.ajaxurl,
        type: "POST",
        contentType: false,
        processData: false,
        data: form_data,
        success: function success(response) {
          // $(".response").text(response);
          if ($(".roadmap-items .tab-wrapper__item.hide").length > 0) {
            $(".expand-extra-items--roadmap").addClass("show");
          }
        }
      });
    });
  }

  function addTopic() {
    $(document).on('click', '.expand-extra-items--roadmap', function (e) {
      $(".roadmap-items .tab-wrapper__item.hide").first().removeClass("hide").addClass("show");

      if ($(".roadmap-items .tab-wrapper__item.hide").length == 0) {
        $(this).removeClass("show");
      }

      $(".roadmap-items .tab-wrapper__item.show").each(function (i) {
        $(this).find(".tab-wrapper__item-number").text(i + 1);
      });
    });
  }

  removeTopic();
  addTopic();
  $(document).ajaxComplete(function () {
    $(".roadmap-items").sortable({
      update: function update() {
        sortTopics();
      }
    });
  });
});